import config from '../../env/config.json';

class Config {
  public getAPIAddress() {
    return config.apiAddress;
  }
}

export default new Config();
